<fieldset class="file-list-container mt-2">
  <legend>{{ 'label.add-files-here' | translate }}</legend>

  <input type="file"
         multiple
         class="d-none"
         (change)="onFileSelected($event)"
         #fileUpload />

    <p *ngIf="!files" class="text-muted">
      {{ 'label.no-file' | translate }}
    </p>

    <ng-container *ngFor="let file of files; let i = index">
      <p class="file-name">
        {{ file.name }}
      </p>
    </ng-container>

    <div>
      <button type="button"
              class="btn btn-primary btn-sm mr-2"
              (click)="fileUpload.click()">
        <fa-icon [icon]="['fas', 'paperclip']" size="sm" class="mr-1"></fa-icon>
        {{ 'label.upload' | translate }}
      </button>

      <button type="button"
              class="btn btn-secondary btn-sm"
              (click)="clear()"
              [disabled]="files.length === 0">
        {{ 'label.clear-files' | translate }}
      </button>
    </div>

    <div *ngIf="errorText"
         class="text-danger mt-2">
      {{ errorText }}
    </div>
  </fieldset>



